import { isObject, get } from 'lodash-es';

import { arrayKeys, noRenderKeys, topLevelKeys } from '../utils/sportradarConfigs';
import { snakeToCapitalized } from '../utils/filters';

export default {
  methods: {
    formatForKeyMapper(obj, fullData, filters={}) {
      // eslint-disable-next-line arrow-body-style
      const makeTree = (_o, pre = '') => {
        return Object.keys(_o).reduce((arr, k) => {
          const key = `${pre ? `${pre}.` : ''}${k}`;
          let label = `${snakeToCapitalized(k)}`;

          // omit things like sr_id
          if (noRenderKeys.includes(k)) return arr;

          const parent = pre.split('.').pop()
          // Filter data sets
          if (filters[parent] && k !== filters[parent]) return arr;

          // get human readable labels instead of ids
          if (arrayKeys[parent]) {
            label = this.getReadablePath(parent, get(fullData, key));
          }

          const node = {
            key,
            label,
          };

          if (isObject(_o[k])) {
            // Object? recurse
            node.children = makeTree(_o[k], node.key);
          }

          arr.push(node);
          return arr;
        }, []);
      };

      return Object.keys(obj).reduce((arr, k) => {
        const label = topLevelKeys[k] || `${snakeToCapitalized(k.split('.').pop())}`;
        if (noRenderKeys.includes(k)) return arr;
        arr.push({
          key: k,
          label,
          ...(isObject(obj[k]) && { children: makeTree(obj[k], k) }),
        });
        return arr;
      }, []);
    },
    getReadablePath(key, data) {
      const { keys, separator } = arrayKeys[key];

      return keys.map((k) => data[k]).join(separator);
    },
    getTranslatedPath(path, map) {
      const re = new RegExp(Object.keys(map).join("|"),"gi");
      return path.replace(re, (matched) => map[matched]);
    },
    makeAbstractPath(path, map) {
      return path.split('.').map((p, idx, fullPath) => {
        if (idx > 0) {
          const prevKey = fullPath[idx - 1];
          if (map[prevKey]) {
            return map[prevKey];
          }
        }

        return p;
      }).join('.');
    },
  },
};
